import { Box, Flex, GridItem, ListItem, SimpleGrid, useMediaQuery } from '@chakra-ui/react';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';

import { H2 } from '@/components/Heading';
import { NextImage } from '@/components/Image';
import { GoToLink } from '@/components/UI/Links/GoToLink';

import breakpoints from '@/../themes/betterstyle-theme/breakpoints';
import { PostItemProps } from '@/models/props/PostItemProps';
import { StrapiUtilsService } from '@/services/StrapiUtilsService';

function PostCardItemOutline(props: PostItemProps) {
    const { title, shortDescription, url, imageUrl, imageAlt } = props;
    const image = imageUrl && StrapiUtilsService.updateUploadsUrl(imageUrl);

    const [isDesktop] = useMediaQuery(`(min-width: ${breakpoints.sm})`, {
        ssr: true,
        fallback: true
    });
    const [desktop, setDesktop]: [
        boolean | undefined,
        Dispatch<SetStateAction<boolean | undefined>>
    ] = useState();

    useEffect(() => {
        setDesktop(isDesktop);
    }, [isDesktop]);

    return (
        <ListItem>
            <SimpleGrid
                as="article"
                columns={{ base: 1, sm: 12 }}
                gap={{ base: 4, md: 8 }}
                border="1px"
                borderColor="grey.200"
                p={7}
                borderRadius="4xl"
                alignItems="center"
            >
                <GridItem colSpan={{ base: 1, sm: 5, md: 3 }}>
                    {image && (
                        <Box
                            pos="relative"
                            h={{ base: 40, sm: 44 }}
                            w={{ base: '100%', sm: '100%' }}
                            border="1px"
                            borderColor="grey.200"
                            borderRadius="3xl"
                            overflow="hidden"
                            position="relative"
                            mx="auto"
                        >
                            <Box
                                className="absolute"
                                position="absolute"
                                left="50%"
                                top="50%"
                                transform="translate(-50%, -50%)"
                                height={{
                                    base: 'calc(100% - 0px)',
                                    xl: 'calc(100% + 35px)'
                                }}
                                width={{
                                    base: 'calc(100% + 80px)',
                                    sm: 'calc(100% + 65px)',
                                    lg: 'calc(100% + 25px)'
                                }}
                            >
                                <NextImage
                                    src={image}
                                    height={desktop ? 250 : 270}
                                    width={desktop ? 300 : 500}
                                    alt={imageAlt ?? title}
                                    style={{ objectFit: 'cover', height: '100%' }}
                                />
                            </Box>
                        </Box>
                    )}
                </GridItem>
                <GridItem
                    as={Flex}
                    pt={3}
                    pb={{ base: 0, md: 3 }}
                    flexDir="column"
                    colSpan={{ base: 1, sm: 7, md: 9 }}
                    h="100%"
                >
                    <H2>{title}</H2>
                    {shortDescription && (
                        <Box
                            dangerouslySetInnerHTML={{
                                __html: shortDescription
                            }}
                        />
                    )}
                    {url && <GoToLink href={url} mt="auto" />}
                </GridItem>
            </SimpleGrid>
        </ListItem>
    );
}

export default PostCardItemOutline;
